import { App, Button, Flex, Input, Space, Typography } from 'antd'
import { Copy, Eye, EyeSlash } from 'iconsax-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

type SecretTokenFieldProps = {
  label: string
  value?: string
  rotating?: boolean
  onRotate: () => void
}

const VISIBLE_CHARS = 3

const maskToken = (value: string) =>
  value.slice(0, VISIBLE_CHARS) +
  '*'.repeat(Math.max(0, value.length - VISIBLE_CHARS))

export const SecretTokenField = ({
  label,
  value,
  rotating,
  onRotate
}: SecretTokenFieldProps) => {
  const { t } = useTranslation()
  const { message } = App.useApp()

  const [revealed, setRevealed] = useState(false)

  const getDisplayValue = () => {
    if (!value) return ''

    return revealed ? value : maskToken(value)
  }

  const displayValue = getDisplayValue()

  const onCopy = async () => {
    if (!value) return

    await navigator.clipboard.writeText(value)
    message.success(t('broker_api.copied'))
  }

  return (
    <Flex vertical gap={4}>
      <Typography.Text type="secondary">{label}</Typography.Text>

      <Space.Compact style={{ width: '100%' }}>
        <Input readOnly value={displayValue} />

        <Button
          icon={revealed ? <EyeSlash size={18} /> : <Eye size={18} />}
          onClick={() => setRevealed((prev) => !prev)}
          disabled={!value}
          title={t(revealed ? 'broker_api.hide' : 'broker_api.reveal')}
        />

        <Button
          icon={<Copy size={18} />}
          onClick={onCopy}
          disabled={!value}
          title={t('broker_api.copy')}
        />

        <Button loading={rotating} onClick={onRotate} disabled={!value}>
          {t('broker_api.regenerate')}
        </Button>
      </Space.Compact>
    </Flex>
  )
}
